import { InternalProductPlace } from '../../../typings/internalProductPlace';

export const UPDATE_INTERNAL_PRODUCT_PLACES = 'UPDATE_INTERNAL_PRODUCT_PLACES';
export type UPDATE_INTERNAL_PRODUCT_PLACES = typeof UPDATE_INTERNAL_PRODUCT_PLACES;

export interface UpdateInternalProductPlaces {
    type: UPDATE_INTERNAL_PRODUCT_PLACES;
    places: InternalProductPlace[];
}

export function updateInternalProductPlacesAction(places: InternalProductPlace[]): UpdateInternalProductPlaces {
    return {
        type: UPDATE_INTERNAL_PRODUCT_PLACES,
        places
    };
}
